import { createAction } from '@reduxjs/toolkit'
import isNull from 'lodash/isNull'
import { call, takeLatest } from 'redux-saga/effects'

import managers from '../../lib/managers'
import { BabylonManager } from '../../lib/managers/BabylonManager'

export const resize3DCanvas = createAction('3D/resizeCanvas')

export function* handleResize3DCanvas() {
    const manager: BabylonManager | null = yield call(managers.get3DManager)

    if (isNull(manager)) return

    yield call(manager.resizeScene)
}

export function* watchFor3DCanvasresize() {
    yield takeLatest(resize3DCanvas.type, handleResize3DCanvas)
}
